import { render, staticRenderFns } from "./Loader2.vue?vue&type=template&id=1ce65b64"
import script from "./Loader2.vue?vue&type=script&lang=js"
export * from "./Loader2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports